export { KontaktModule } from './kontakt.module';
export { KontaktComponent } from './kontakt.component';

